import { render, staticRenderFns } from "./GeneralEventDetail.vue?vue&type=template&id=9e8e9cb4&"
import script from "./GeneralEventDetail.vue?vue&type=script&lang=js&"
export * from "./GeneralEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports